export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Open Dispute"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancel"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Send"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A moderator will join to assist. Please select a reason and attach evidence."])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Send to Moderator"])}
}